import React from 'react'
import { Container, Col, Row, Image } from "react-bootstrap";
import Recognized from '../../../Assets/images/cultbrilliance/img_recognized.jpg' 
import Teamone from '../../../Assets/images/cultbrilliance/img_kathleen.jpg'
import Teamtow from '../../../Assets/images/cultbrilliance/img_tony.jpg'
import Button from 'react-bootstrap/Button';
import { NavLink } from 'react-router-dom';
const MeetourTeam = () => {
  return (
    <>
    <section className='cbr_recognized_authenticty'>
    <Container fluid >
     <Row>
        <Col md={12} lg={6} sm={12} className='p-0'>
         <div className='cbr_recogniz_img'>
          <img src={Recognized} alt='Recognized'className="img-fluid" />
         </div>
        </Col>
        <Col md={12} lg={6} sm={12} className=''>
         <div className='cbr_Recognized_authenticity regnoz'>
            <div className='cbr_recogniz'>
                <h2>Recognized authenticity</h2>
                <p>Cultured diamonds have the same “growing pains” as mined diamonds and will display the same color 
                    and clarity variations which are measured and disclosed in a diamond certificate. 
                    The International Gemological Institute (IGI) grades lab created diamonds according to the 
                    same protocol as mined diamonds. Coming in 2019, the Gemological Institute of America (GIA) 
                    will begin certification of lab diamonds. In 2018, the Federal Trade Commission (FTC) 
                    changed the definition of “diamond” to remove the requirement that it be “from the earth”,
                     and allowed for laboratory created diamonds to be referred to as “cultured diamonds”.</p>
            </div>
         </div>
        </Col>
     </Row>
{/* \\\\\\\\\\\\\\\\\\Meet Our Team \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\   */}
     <Row className='meet_our_team'>
     <Col md={12} lg={6} sm={12} className=''>
         <div className='cbr_Recognized_authenticity regnoz'>
            <div className='cbr_recogniz'>
                <h2>Meet Our Team</h2>
                <p>
                <span className='k_bold'><b>Kathleen</b></span> grew up near Philadelphia and now 
                lives in Atlanta. She is passionate about lab grown diamonds because of the value and choice they offer to consumers! 
                Kathleen thinks of her customers as family. Her best compliment is a referral!</p>
                <p><span className='k_bold'><b>Tony</b></span> is originally from the UK.
                He’s traveled the world and finally settled in North Georgia. He has a lovely wife and 3 children.<br/> 
                Tony has been in the jewelry business for over 30 years and sees the value in cultured diamonds. </p>
                <p>Both Tony and Kathleen would love to hear from you – why not pick up the phone!</p>
                <br/>
                <NavLink className="cd_btn_rama_color" to='/contact'>CONTACT US </NavLink>
            </div>
         </div>
        </Col>
        <Col md={6} lg={3} sm={12}>
         <div className='cbr_recogniz_img'>
          <img src={Teamone} alt='Recognized' className="img-fluid" />
         </div>
        </Col>
        <Col md={6} lg={3} sm={12}>
         <div className='cbr_recogniz_img'>
          <img src={Teamtow} alt='Recognized' className="img-fluid" />
         </div>
        </Col>
        
     </Row>
    </Container>
    </section>
    </>
  )
}

export default MeetourTeam
